// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__12seq","label":"CategoryService_label__3VSHn","location":"CategoryService_location__Df8-M"};